function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.554 20.499a1.052 1.052 0 01-.793-.353 1.083 1.083 0 01-.249-.855L2.154 8.118a2.038 2.038 0 011.963-1.719h1.958V4.926A4.431 4.431 0 0110.502.499a4.431 4.431 0 014.426 4.426v1.474h2.013a2.01 2.01 0 011.93 1.733l1.6 11.148a1.014 1.014 0 01-.179.849.993.993 0 01-.79.37zM3.127 8.262L1.485 19.428a.1.1 0 00.017.071.063.063 0 00.053.018h17.947c.012.011.015 0 .009-.029l-.009-.047-1.608-11.176a1.016 1.016 0 00-.955-.879h-2.012v2.405a1.149 1.149 0 01.655 1.037 1.148 1.148 0 01-1.146 1.147 1.149 1.149 0 01-1.149-1.147 1.15 1.15 0 01.656-1.036V7.385H7.059v2.406a1.149 1.149 0 01.655 1.037 1.147 1.147 0 01-1.146 1.147 1.149 1.149 0 01-1.149-1.147 1.149 1.149 0 01.656-1.036V7.385H4.117a1.062 1.062 0 00-.99.877zm11.145 2.565a.164.164 0 00.166.164.163.163 0 00.162-.164.164.164 0 00-.162-.164.165.165 0 00-.166.164zm-7.869 0a.164.164 0 00.165.164.163.163 0 00.163-.164.164.164 0 00-.163-.164.165.165 0 00-.166.164zm7.54-4.426V4.926a3.446 3.446 0 00-3.441-3.442A3.446 3.446 0 007.06 4.926v1.473z",
  stroke: "transparent",
  strokeMiterlimit: 10
});

var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 21.004,
      height: 21,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgShoppingBag, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ShoppingBag.4221109a.svg";
export { ForwardRef as ReactComponent };